import { initializeApp } from 'firebase/app'
import {
  connectAuthEmulator,
  initializeAuth,
  inMemoryPersistence,
} from 'firebase/auth'
import {
  connectDatabaseEmulator,
  Database,
  getDatabase,
  ref as dbRef,
} from 'firebase/database'
import { connectFirestoreEmulator, getFirestore } from 'firebase/firestore'
import { connectStorageEmulator, getStorage } from 'firebase/storage'

import { env } from '@/config'

const firebaseConfig = {
  apiKey: env.VITE_FIREBASE_API_KEY || 'placeholder-api-key',
  authDomain:
    env.VITE_FIREBASE_AUTH_DOMAIN ||
    `${env.VITE_FIREBASE_PROJECT_ID || 'oakoi-wedding'}.firebaseapp.com`,
  projectId: env.VITE_FIREBASE_PROJECT_ID || 'oakoi-wedding',
  storageBucket:
    env.VITE_FIREBASE_STORAGE_BUCKET ||
    `${env.VITE_FIREBASE_PROJECT_ID || 'oakoi-wedding'}.appspot.com`,
  messagingSenderId:
    env.VITE_FIREBASE_MESSAGING_SENDER_ID || 'placeholder-sender-id',
  appId: env.VITE_FIREBASE_APP_ID || 'placeholder-app-id',
  databaseURL:
    env.VITE_FIREBASE_DATABASE_URL ||
    'https://oakoi-wedding-default-rtdb.asia-southeast1.firebasedatabase.app',
}

const app = initializeApp(firebaseConfig)
export const db = getFirestore(app)
export const rtdb = getDatabase(app)

export function ref(db: Database, path?: string) {
  const prefix = env.VITE_FIRESTORE_PREFIX || ''
  const suffix = env.VITE_FIRESTORE_SUFFIX || ''
  if (!path) return dbRef(db)

  const cleanPath = path.startsWith('/') ? path.slice(1) : path
  const pathParts = cleanPath.split('/')
  pathParts[0] = `${prefix}${pathParts[0]}${suffix}`
  const prefixedPath = pathParts.join('/')

  return dbRef(db, path.startsWith('/') ? `/${prefixedPath}` : prefixedPath)
}

export const storage = getStorage(app)
export const auth = initializeAuth(app, {
  persistence: [inMemoryPersistence],
})

// Connect to emulator in development
if (import.meta.env.DEV && env.VITE_FIREBASE_EMULATORS) {
  connectFirestoreEmulator(db, 'localhost', 8080)
  connectDatabaseEmulator(rtdb, 'localhost', 9000)
  connectAuthEmulator(auth, 'http://localhost:9099', {
    disableWarnings: true,
  })
  connectStorageEmulator(storage, 'localhost', 9199)
}
